import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ContentData {

  constructor(private _api: FsApi) {}

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

  public get(query): Observable<any> {
    return this._api.get('contents', query, { key: 'contentWidget' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'contents', data, { key: 'contentWidgets', ...config });
  }

  public put(contentWidget, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`contents/${contentWidget.id}`, contentWidget, { key: 'contentWidget', ...config });
  }

  public post(contentWidget): Observable<any> {
    return this._api.post('contents', contentWidget, { key: 'contentWidget' });
  }

  public delete(contentWidget): Observable<any> {
    return this._api.delete(`contents/${contentWidget.id}`, contentWidget, { key: 'contentWidget' });
  }
}
